module.exports = __webpack_public_path__ + "static/media/educationprofes.9caf0b0c.webp";